import { Component, Input } from '@angular/core';
import { AddressHelper } from '../../services/address-helper.service';

@Component({
  selector: 'address-editor',
  templateUrl: './address-editor.component.html',
  styleUrls: ['./address-editor.component.scss'],
  standalone: false
})
export class AddressEditorComponent {
  @Input()
  address: AddressHelper;

  get addressFormGroup() {
    return this.address.addressFormGroup;
  }

  get isHidden() {
    return this.address.isHidden;
  }

  get isRequired() {
    return this.address.isRequired;
  }
}
